import { rootStyle } from "./styles";

import type { SerializedStyles } from "@emotion/core";

type Input = {
  css?: SerializedStyles | SerializedStyles[];
};

export const useThis = (input: Input) => {
  const { css: extendCss } = input;

  const getApplyStyles = (): SerializedStyles[] => {
    if (!extendCss) return [rootStyle];
    if (Array.isArray(extendCss)) return [rootStyle, ...extendCss];
    return [rootStyle, extendCss];
  };

  return {
    applyStyles: getApplyStyles(),
  };
};
